



























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Empty from "@/components/empty.vue";
@Component({
  components: {
    Empty,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifEdit: any;
  @Prop()
  private patient: any;
  @Prop()
  private data: any;
  @Watch("data", { immediate: true, deep: true })
  private dataChange() {
    this.drawBar();
    this.drawLine();
  }
  private text: any = "";
  private zhuzhuangtu: any = {};
  private boxingtu: any = {};
  private drawBar() {
    this.zhuzhuangtu = {
      color: ["#0a97a2"],
      tooltip: {
        show: true,
        trigger: "item",
      },
      grid: {
        left: "60",
        right: "2%",
        top: "20",
        bottom: "40",
      },
      xAxis: {
        type: "category",
        axisLabel: {
          color: "rgba(0,0,0,。8)",
        },
        axisLine: {
          lineStyle: {
            color: "rgba(0,0,0,0.6)",
          },
        },
        data: this.data["经络柱状图"].title,
      },
      yAxis: {
        name: "",
        type: "value",
        axisLine: {
          show: true,
        },
      },
      series: [
        {
          type: "bar",
          barWidth: "40",
          data: this.data["经络柱状图"].data,
          itemStyle: {
            color: "#6C99F6",
          },
        },
      ],
    };
  }
  private drawLine() {
    const xAxis: any = [];
    for (let index = 0; index < this.data["局部脉搏波形图"]; index++) {
      xAxis.push(index + 1);
    }
    this.boxingtu = {
      color: ["#6C99F6"],
      grid: {
        left: "60",
        right: "2%",
        top: "20",
        bottom: "40",
      },
      xAxis: {
        type: "category",
        data: xAxis,
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          data: this.data["局部脉搏波形图"],
          type: "line",
          smooth: true,
        },
      ],
    };
  }
}
